<div class="goreact-modal submit-video-reminder-dialog ngx-dialog" data-cy="submit-video-reminder-dialog">
  <div class="goreact-modal-header">
    <h4 [id]="data.dialogTitleId" class="modal-title" translate="submit-video-reminder_title"></h4>
    <button
      class="close-btn"
      type="button"
      data-cy="submit-video-reminder-close"
      [attr.aria-label]="'common_close' | translate"
      (click)="close()">
      <i class="ficon-app-x" aria-hidden="true"></i>
    </button>
  </div>

  <div class="goreact-modal-body">
    <img
      class="submit-video-reminder-dialog__graphic"
      [src]="graphicSrc"
      alt="">
    <h5 translate="submit-video-reminder_heading"></h5>
    <p translate="submit-video-reminder_message"></p>
  </div>

  <div class="goreact-modal-footer">
    <mat-checkbox
      class="submit-video-reminder-dialog__remember"
      data-cy="submit-video-reminder-dont-show-again"
      color="primary"
      [checked]="dontShowAgain"
      (change)="dontShowAgain = $event.checked">
      {{ 'submit-video-reminder_dont-show-again' | translate }}
    </mat-checkbox>
    <button
      type="button"
      class="goreact-btn primary-btn"
      data-cy="submit-video-reminder-complete-tasks"
      (click)="close()"
      translate="submit-video-reminder_complete-tasks">
    </button>
  </div>
</div>
